import React from "react";

const BranchFinancialSection = ({
  formData,
  updateNestedField,
  updateField,
  errors,
}) => {
  return (
    <div className="space-y-4">
      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="font-semibold mb-3">Bank Account Details</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Account Name
            </label>
            <input
              type="text"
              value={formData.financial.bankAccount.accountName}
              onChange={(e) =>
                updateNestedField(
                  "financial",
                  "bankAccount",
                  "accountName",
                  e.target.value
                )
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Account Number
            </label>
            <input
              type="text"
              value={formData.financial.bankAccount.accountNumber}
              onChange={(e) =>
                updateNestedField(
                  "financial",
                  "bankAccount",
                  "accountNumber",
                  e.target.value
                )
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Bank Name
            </label>
            <input
              type="text"
              value={formData.financial.bankAccount.bankName}
              onChange={(e) =>
                updateNestedField(
                  "financial",
                  "bankAccount",
                  "bankName",
                  e.target.value
                )
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Branch
            </label>
            <input
              type="text"
              value={formData.financial.bankAccount.branch}
              onChange={(e) =>
                updateNestedField(
                  "financial",
                  "bankAccount",
                  "branch",
                  e.target.value
                )
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              IFSC Code
            </label>
            <input
              type="text"
              value={formData.financial.bankAccount.ifscCode}
              onChange={(e) =>
                updateNestedField(
                  "financial",
                  "bankAccount",
                  "ifscCode",
                  e.target.value.toUpperCase()
                )
              }
              className={`w-full px-3 py-2 border rounded-lg font-mono ${
                errors.ifscCode ? "border-red-500" : "border-gray-300"
              }`}
              placeholder="HDFC0001234"
              maxLength="11"
            />
            {errors.ifscCode && (
              <p className="text-red-500 text-xs mt-1">{errors.ifscCode}</p>
            )}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Cash Limit (₹)
          </label>
          <input
            type="number"
            value={formData.financial.cashLimit}
            onChange={(e) =>
              updateField(
                "financial",
                "cashLimit",
                parseInt(e.target.value) || 0
              )
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Daily Transaction Limit (₹)
          </label>
          <input
            type="number"
            value={formData.financial.transactionLimit.daily}
            onChange={(e) =>
              updateNestedField(
                "financial",
                "transactionLimit",
                "daily",
                parseInt(e.target.value) || ""
              )
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Monthly Transaction Limit (₹)
          </label>
          <input
            type="number"
            value={formData.financial.transactionLimit.monthly}
            onChange={(e) =>
              updateNestedField(
                "financial",
                "transactionLimit",
                "monthly",
                parseInt(e.target.value) || ""
              )
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default BranchFinancialSection;
